import { FormApi } from 'final-form'
import { forEach, get, keys, noop } from 'lodash'
import React, { useEffect, useState } from 'react'

import FormContext from './FormContext'

type TFormGetter = {
  children?: React.ReactNode
  form?: FormApi
  setForm?: (val: FormApi) => void
  initialValues?: {
    [key: string]: any
  }
  [key: string]: any
  onlyMountWhenValuesAreSet?: boolean
}

const FormGetter = (props: TFormGetter): React.ReactElement => {
  const {
    children,
    form,
    setForm = noop,
    initialValues,
    onlyMountWhenValuesAreSet,
    ...rest
  } = props

  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    if (form && setForm) {
      setForm(form)
      form.batch(() => {
        forEach(keys(initialValues), (key) =>
          form.change(key, get(initialValues, key)),
        )
      })
      if (onlyMountWhenValuesAreSet) {
        setTimeout(() => setHasMounted(true), 0)
      }
    }
  }, [])

  if (onlyMountWhenValuesAreSet && !hasMounted) {
    return <></>
  }

  return (
    <FormContext.Provider value={{ form, ...rest }}>
      {children}
    </FormContext.Provider>
  )
}

export default FormGetter
